import React from 'react';
const facts = [{
  value: '90',
  label: 'Practices planned, in order'
}, {
  value: '300',
  label: 'Pages of clocked, two-track practices'
}, {
  value: '90/75/60',
  label: 'Minute versions of every practice'
}, {
  value: '24',
  label: 'Planning worksheets'
}];
export function SocialProofBar() {
  return <section className="w-full bg-plum-deep" data-id="element-245" data-mp="25tn9hvhafktk">
      <div className="max-w-6xl mx-auto px-5 pb-14 sm:pb-16" data-id="element-246" data-mp="25qrb661j2u4l">
        <div className="grid grid-cols-2 gap-px overflow-hidden rounded-2xl border border-plum-line bg-plum-line sm:grid-cols-4" data-id="element-247" data-mp="32htieul8szdn">
          {facts.map(fact => <div key={fact.label} className="bg-plum px-4 py-5 text-center" data-id="element-248" data-mp="2ti6i6c491zm6">
              <div className="font-display font-semibold text-3xl sm:text-4xl leading-none text-gold" data-id="element-249" data-mp="2tk9gdjfk2z1z">
                {fact.value}
              </div>
              <div className="mt-2 text-[10px] font-semibold uppercase tracking-widest text-white/60" data-id="element-250" data-mp="1i418r3l9oxjg">
                {fact.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}